export default __webpack_public_path__ + "static/media/complex_slide01.302534a8.jpg";